export enum ProviderAttachmentCategoryType {
  CstLicense = '36146511-00c7-45ae-ae59-4e510fb79e93',
  CommercialRegistration = '52d57310-b92c-45db-a35e-7555269fbb71',
  DelegationLetter = 'ea680a6d-e1d9-4473-83a6-5a8770c24b42',
  NationalAddress = 'b54edbdc-b28f-462f-a554-fd61ecf14d86',
  ZakatTaxCertificate = '4fa3ea15-0d1d-434f-9961-788bd6ca4449',
}